module.exports = __webpack_public_path__ + "static/media/Climate.263436b6.svg";